import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ArrowDown from "../../../Theming/icons/ArrowDown";
import { withTranslation } from "react-i18next";
import "./index.css";
const Carousel = ({
  children,
  customClass,
  slides,
  tabletSlides,
  mobileSlides,
  showDots = true,
  showArrows = true,
  presetActiveSlideIndex = null,
  t
}) => {
  const [showCarouselDots, setShowCarouselDots] = useState(false);
  const [showCarouselArrows, setShowCarouselArrows] = useState(false);
  const [carouselTouch, setCarouselTouch] = useState(null);
  const [carouselSlideItems, setCarouseSlideItems] = useState([]);
  const [activeCarouselSlide, setActiveCarouselSlide] = useState(0);
  const [carouselOffset, setCarouselOffset] = useState(0);
  const global = useSelector(state => state.global);
  const isMobile = global.isMobile === true;
  const isTablet = global.isTablet === true && !isMobile;
  const slideItemsToShow = isMobile ? parseInt(mobileSlides, 10) : isTablet ? parseInt(tabletSlides ?? mobileSlides, 10) : parseInt(slides, 10);
  const totalSlides = Math.ceil(children.length / slideItemsToShow);
  const cssOffsetPercentage = -100;
  const touchThreshold = 75; // length of screenX coordinates when user swipes left or right

  useEffect(() => {
    if (totalSlides > 1) {
      setShowCarouselDots(showDots);
      setShowCarouselArrows(showArrows);
    }
    setCarouseSlideItems(Array(totalSlides).fill().map((_, i) => i * slideItemsToShow).map(item => children.slice(item, item + slideItemsToShow)));
    return function removeDotsAndArrows() {
      setShowCarouselDots(false);
      setShowCarouselArrows(false);
    };
  }, [showDots, showArrows, global, slideItemsToShow, children]);
  useEffect(() => {
    if (presetActiveSlideIndex !== null) {
      setActiveCarouselSlide(presetActiveSlideIndex);
      return function resetPresetActiveSlideIndex() {
        setActiveCarouselSlide(0);
      };
    }
  }, [presetActiveSlideIndex]);
  useEffect(() => {
    if (totalSlides <= 1) {
      setCarouselOffset(0);
      return;
    }
    if (totalSlides - activeCarouselSlide < 1) {
      setCarouselOffset((totalSlides - 1) * cssOffsetPercentage);
      return;
    }
    setCarouselOffset(activeCarouselSlide * cssOffsetPercentage);
  }, [activeCarouselSlide, totalSlides, cssOffsetPercentage]);
  const handleNext = () => {
    const nextSlide = activeCarouselSlide + 1;
    if (nextSlide <= carouselSlideItems.length - 1) {
      setActiveCarouselSlide(nextSlide);
    }
  };
  const handlePrev = () => {
    const prevSlide = activeCarouselSlide - 1;
    if (prevSlide >= 0) {
      setActiveCarouselSlide(prevSlide);
    }
  };
  const handleSwipe = isNext => {
    if (isNext) {
      handleNext();
    } else {
      handlePrev();
    }
  };
  const handleTouchStart = e => {
    setCarouselTouch(e.changedTouches[0].screenX);
  };
  const handleTouchEnd = e => {
    const touchDiff = carouselTouch - e.changedTouches[0].screenX;
    if (Math.abs(touchDiff) >= touchThreshold) {
      setCarouselTouch(e.changedTouches[0].screenX);
      handleSwipe(touchDiff > 0);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `carousel ${customClass && "carousel--" + customClass}`
  }, showCarouselArrows && /*#__PURE__*/React.createElement("div", {
    className: `carousel__controls ${showCarouselDots && "carousel__controls--active"}`
  }, /*#__PURE__*/React.createElement("button", {
    className: "carousel__controls-button carousel__controls-button--prev",
    onClick: handlePrev,
    disabled: activeCarouselSlide === 0,
    "aria-label": t("CarouselPrev")
  }, /*#__PURE__*/React.createElement(ArrowDown, {
    customClass: "carousel__controls-arrow--prev carousel__controls-arrow"
  })), /*#__PURE__*/React.createElement("button", {
    className: "carousel__controls-button carousel__controls-button--next",
    onClick: handleNext,
    disabled: activeCarouselSlide === carouselSlideItems.length - 1,
    "aria-label": t("CarouselNext")
  }, /*#__PURE__*/React.createElement(ArrowDown, {
    customClass: "carousel__controls-arrow--next carousel__controls-arrow"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "carousel__slider",
    style: {
      transform: `translateX(${carouselOffset}%)`
    }
  }, carouselSlideItems.map((slideItems, i) => {
    const activeSlide = i === activeCarouselSlide;
    return /*#__PURE__*/React.createElement("ul", {
      key: customClass + i,
      className: `carousel__slider-items ${(activeSlide ? "carousel__slides-item--is-active" : "", customClass ? `${customClass}-items` : "")}`,
      role: "tablist",
      "aria-label": "Partner Logos Carousel"
    }, slideItems.map((slideItem, j) => {
      return /*#__PURE__*/React.createElement("li", {
        key: slideItem.key || `slide-${i}-${j}`,
        className: `carousel__slider-item ${activeSlide && "carousel__slides-item--in-view"} ${customClass ? `${customClass}-item` : ""}`,
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        role: "tab",
        "aria-selected": "true",
        tabindex: "0"
      }, slideItem);
    }));
  })), showCarouselDots && /*#__PURE__*/React.createElement("div", {
    className: "carousel__dots"
  }, carouselSlideItems.map((_, i) => {
    const activeDot = i === activeCarouselSlide;
    return /*#__PURE__*/React.createElement("span", {
      key: `page-${i}`,
      className: `carousel__dots-dot ${activeDot ? "carousel__dots-dot--is-active" : ""}`
    });
  })));
};
export default withTranslation()(Carousel);